import Immutable from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModalActions from 'app/actions/ModalActions';
import PreviewActions from 'app/actions/PreviewActions';
import { selectCommentSummary } from 'app/selectors/bibs/CommentSummarySelector';
import { selectPreviewTransactions } from 'app/selectors/PreviewSelector';
import ShareFeedbackModal, { FEEDBACK_CATEGORY } from './ShareFeedbackModal';

const mapStateToProps = state => ({
  // The panel only renders when a summary exists, but the modal mounts with it — keep the
  // prop a Map so an eligibility flicker can't crash the tree.
  commentSummary: selectCommentSummary(state) || Immutable.Map(),
  isSubmitting: selectPreviewTransactions(state).getIn([FEEDBACK_CATEGORY, 'isLoading'], false)
});

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch),
  previewActions: bindActionCreators(PreviewActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ShareFeedbackModal);
